import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-message-block" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoMessageBlock',
  props: {
  authenticatedUser: { type: Boolean, required: true },
  isFilledList: { type: Boolean, default: false },
  marketId: { type: String, required: false },
  showAllMarkets: { type: Boolean, required: true },
  isPositions: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const infoMessage = computed(() => {
  if (!props.authenticatedUser) {
    const loginToSee = t('modules.myOrders.helpers.loginToSee');

    return loginToSee;
  }
  const [base, quote] = props.marketId?.split('_') ?? [];
  const isMessageForAllMarkets = props.showAllMarkets && base && quote;

  if (props.isPositions) {
    const noPositions = t('modules.myOrders.helpers.noOpenPositions');
    const noPositionsForMarket = t('modules.myOrders.helpers.noOpenPositionsForMarket', { market: `${base}/${quote}` });

    return isMessageForAllMarkets ? noPositions : noPositionsForMarket;
  }

  if (props.isFilledList) {
    const noFilledOrders = t('modules.myOrders.helpers.noFills');
    const noFilledOrdersForMarket = t('modules.myOrders.helpers.noFillsForMarket', { market: `${base}/${quote}` });

    return isMessageForAllMarkets ? noFilledOrders : noFilledOrdersForMarket;
  }

  const noOpenOrders = t('modules.myOrders.helpers.noOpenOrders');
  const noOpenOrdersForMarket = t('modules.myOrders.helpers.noOpenOrdersForMarket', { market: `${base}/${quote}` });

  return isMessageForAllMarkets ? noOpenOrders : noOpenOrdersForMarket;
});

const seeFullHistoryRouteLink = computed(() => ({
  name: 'trading-accounts.orders',
  query: {
    status: 'inactive',
  },
}));

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_ot_link_internal = _resolveComponent("ot-link-internal")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ot_icon, {
      class: "info-message-block__icon",
      name: __props.authenticatedUser ? 'layer' : 'lock-circle',
      "inherit-stroke": true
    }, null, 8, ["name"]),
    _createElementVNode("span", null, _toDisplayString(infoMessage.value), 1),
    (__props.isFilledList && __props.authenticatedUser)
      ? (_openBlock(), _createBlock(_component_i18n_t, {
          key: 0,
          keypath: "modules.myOrders.helpers.seeFullHistory.text",
          tag: "div",
          scope: "global"
        }, {
          linkText: _withCtx(() => [
            _createVNode(_component_ot_link_internal, {
              to: seeFullHistoryRouteLink.value,
              title: _ctx.$t('modules.myOrders.helpers.seeFullHistory.linkText')
            }, null, 8, ["to", "title"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})